var CssVariables = {
  '--up-black-0': '#ffffff',
  '--up-black-5': '#f5f5f5',
  '--up-black-10': '#eaeaea',
  '--up-black-20': '#d0d0d0',
  '--up-black-30': '#bababa',
  '--up-black-40': '#aaaaaa',
  '--up-black-50': '#8a8a8a',
  '--up-black-60': '#646464',
  '--up-black-80': '#363636',
  '--up-black-100': '#171717',
  '--up-solid-black': '#000000',
  '--up-blue-5': '#f2f5ff',
  '--up-blue-7': '#e4eaff',
  '--up-blue-10': '#c5d1fc',
  '--up-blue-20': '#c6d2ff',
  '--up-blue-30': '#9fb3ff',
  '--up-blue-35': '#587af6',
  '--up-blue-40': '#3b5feb',
  '--up-blue-50': '#2543b6',
  '--up-blue-filter': 'brightness(0) saturate(100%) invert(33%) sepia(98%) saturate(4438%) hue-rotate(225deg) brightness(96%) contrast(97%)',
  '--up-red-5': '#FFF5F5',
  '--up-red-10': '#ffe5e5',
  '--up-red-50': '#d64949',
  '--up-red-70': '#b02b2b',
  '--up-yellow-10': '#fef6e9',
  '--up-yellow-20': '#E5B917',
  '--up-yellow-35': '#ffe55b',
  '--up-yellow-40': '#ffc045',
  '--up-yellow-45': '#E8C234',
  '--up-yellow-50': '#a8870f',
  '--up-yellow-70': '#846c18',
  '--up-green-5': '#F6FBF8',
  '--up-green-10': '#ecf7f0',
  '--up-green-30': '#b6d53a',
  '--up-green-40': '#2ecc71',
  '--up-green-50': '#0da125',
  '--up-green-70': '#0b6e1b',
  '--up-orange-30': '#ffa05b',
  '--up-orange-40': '#fd9d52',
  '--up-teal-50': '#20b2aa',
  '--up-purple-10': '#F7EDF7',
  '--up-purple-50': '#9048c8',
  '--up-purple-70': '#753675',
  '--up-light-pink-50': '#ffd1ff',
  '--up-light-blue-50': '#88d9f8',
  '--up-bright-red-50': '#ff425c',
  '--up-bright-pink-60': '#ff709f',
  '--up-steel-blue-10': '#ECF0F7',
  '--up-steel-blue-70': '#374F78',
  '--box-shadow-dark-dialog': '0px 0px 12px rgba(0, 0, 0, 0.16)',
  '--box-shadow-side-drawer': '-4px 0px 12px rgba(0, 0, 0, 0.08)',
  '--box-shadow-main-content': '0px 0px 12px rgba(0, 0, 0, 0.08)',
  '--font-family': "'Source Sans Pro', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
};
export { CssVariables as default };
//# sourceMappingURL=CssVariables.js.map
